class FFHeaderAccordion {
	active = true
	oldWidth = window.innerWidth
  DOM: {
    entries: NodeListOf<HTMLElement>
    triggers: NodeListOf<HTMLElement>
  }
	
	constructor(){
    this.DOM = {
      entries: document.querySelectorAll('#ff-accordion-main-nav .ff-accordion-entry'),
      triggers: document.querySelectorAll('#ff-accordion-main-nav .ff-accordion-header'),
    }
		this.events();
	}

	events(){
    this.DOM.triggers.forEach(el => {
      el.addEventListener( 'click', this.toggle.bind(this) )
    })
		window.addEventListener( 'optimizedResize', this.checkAccordion.bind(this) );
	}

	//remove accordion classes and styles when resizing up
	checkAccordion(){
		const newWidth = window.innerWidth;
		if( newWidth !== this.oldWidth && newWidth >= 768 && this.active ){
			this.active = false;
			this.collapseAll();
		}
		this.oldWidth = newWidth;
	}

	toggle(e: MouseEvent){
		e.preventDefault();
    const target = e.currentTarget
    if( !(target instanceof HTMLElement )) return
		const entry = target.parentNode;
    if( !(entry instanceof HTMLElement )) return
		const wrapper = entry.querySelector( '.ff-wrap-accordion-content' );
    if( !(wrapper instanceof HTMLElement )) return
		const content = wrapper.querySelector( '.ff-accordion-content' );
    if( !(content instanceof HTMLElement )) return
		const h = content.clientHeight;

		
		if( entry.classList.contains( 'ff-active' ) ){
			this.active = false;
			entry.classList.remove( 'ff-active' );
			wrapper.removeAttribute('style');
		}else{
			this.active = true;
			this.collapseAll();
			entry.classList.add( 'ff-active' );
			wrapper.style.height = `${h}px`;
			wrapper.style.opacity = "1";
		}
	}

	collapseAll(){
    this.DOM.entries.forEach(el => {
			el.classList.remove( 'ff-active' );
      const wrapper = el.querySelector( '.ff-wrap-accordion-content' );
      if( !wrapper ) return
			wrapper.removeAttribute('style');
    })
	}
};

new FFHeaderAccordion()